import React from 'react'
import AddCourse from '../components/instructor/AddCourse';
import InstructorNavbar from "../components/instructor/InstructorNavbar";



const AddCoursePage = () => {
    return ( 
        <>
        <InstructorNavbar/>
        <AddCourse/>
        </>
     );
}
 
export default AddCoursePage;